import { render, staticRenderFns } from "./CardList.vue?vue&type=template&id=2f047feb&lang=pug&"
import script from "./CardList.vue?vue&type=script&lang=ts&"
export * from "./CardList.vue?vue&type=script&lang=ts&"
import style0 from "./CardList.vue?vue&type=style&index=0&id=2f047feb&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports